/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import React, { useEffect } from 'react';
import { Switch, Route, Redirect, useLocation } from 'react-router-dom';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';
import FormBuilder from 'containers/FormBuilder';
import DebugGraph from 'containers/DebugGraph';
import NotFoundPage from 'containers/NotFoundPage';
import injectReducer from 'utils/injectReducer';
import { compose } from 'redux';
import { useDispatch } from 'react-redux';

import { getRuntimeConfigOnStartup } from './runtime-config';
import FormPreview from '../FormPreview';
import FormListLayout from '../../components/FormList';
import { RedirectToFormList, RedirectToFormBuilder, RedirectToFormPreview, RedirectToFormEdition } from '../../components/Redirect';
import reducer from './reducer';
import GroupingListLayout from '../../components/GroupingList';
import GeneralSettings from '../../components/GeneralSettingsView/index.tsx';

export const App = React.forwardRef((props, ref) => { // eslint-disable-line no-unused-vars
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    if (window.location.pathname.indexOf('continue') === -1) {
      localStorage.setItem('pathname', window.location.pathname);
    } else {
      localStorage.setItem('pathname', location.pathname);
    }
  }, [location]);

  useEffect(() => {
    const initializeApp = async () => {
      await getRuntimeConfigOnStartup(dispatch);
    };

    initializeApp();
  }, [dispatch]);

  return (
    <Switch>
      <Route exact path="/(|groupings/)" render={() => <Redirect to="/credential-type/6/groupings/" />} />
      <Route exact path="/credential-type/:credentialTypeId/groupings" component={GroupingListLayout} />
      <Route exact path="/credential-type/:credentialTypeId/groupings/:groupingId/forms" component={FormListLayout} />
      <Route exact path="/credential-type/:credentialTypeId/groupings/:groupingId" render={({ match: { params } }) => <Redirect to={`/credential-type/${params.credentialType}/groupings/${params.groupingId}/forms`} />} />
      <Route exact path="/credential-type/:credentialTypeId/groupings/:groupingId/forms/form-builder" component={FormBuilder} />
      <Route exact path="/credential-type/:credentialTypeId/groupings/:groupingId/forms/:formId" component={FormBuilder} />
      <Route path="/credential-type/:credentialTypeId/groupings/:groupingId/forms/:formId/preview" component={FormPreview} />
      <Route exact path="/groupings/:groupingId/forms" component={RedirectToFormList} />
      <Route exact path="/groupings/:groupingId" component={RedirectToFormList} />
      <Route exact path="/groupings/:groupingId/forms/form-builder" component={RedirectToFormBuilder} />
      <Route exact path="/groupings/:groupingId/forms/:formId" component={RedirectToFormEdition} />
      <Route path="/groupings/:groupingId/forms/:formId/preview" component={RedirectToFormPreview} />
      <Route exact path="/continue" render={() => (<Redirect to={localStorage.getItem('pathname') || '/'} />)} />
      <Route exact path="/general-settings" component={GeneralSettings} />
      <Route exact path="/debug/graph" component={DebugGraph} />
      <Route path="*" component={NotFoundPage} />
    </Switch>
  );
});

App.displayName = 'App';

const withReducer = injectReducer({ key: 'runtimeConfig', reducer });

export default compose(
  withReducer,
  DragDropContext(HTML5Backend),
)(App);
